import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { MarkerPostDTO } from '../../../features/staff-monitor/model/marker-post.dto';
import { sanitizePayload } from '../../utils/sanitize-payload';
import type { MarkerListDTO } from '../../../features/staff-monitor/model/marker-list.dto';
import type { MarkerImportPostDTO } from '../../../features/session/model/marker-import-post.dto';

@Injectable()
export class MarkerService {
  private readonly apiUrl = environment.apiUrl;
  private readonly http = inject(HttpClient);

  getAll(recordingId: string): Observable<MarkerListDTO[]> {
    return this.http.get<MarkerListDTO[]>(`${this.apiUrl}/recordings/${recordingId}/markers`);
  }

  addMarker(recordingId: string, markerData: MarkerPostDTO): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/recordings/${recordingId}/markers`, sanitizePayload(markerData));
  }

  addMarkerImport(recordingId: string, markerImport: MarkerImportPostDTO): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/recordings/${recordingId}/markers/import-test-results`, markerImport);
  }

  deleteMarker(recordingId: string, groupId: string, mindDeviceIds: string[]): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/recordings/${recordingId}/marker-group/${groupId}`, {
      body: sanitizePayload({ mindDeviceIds }),
    });
  }
}
